import { VerifyMethodType } from "shared/types";
import { VerifiedItem } from "../../types/verified";
import { BankSourcesTable } from "./components/BankSourcesTable";
import { PayrollTable } from "./components/PayrollTable";
import { PaystubTable } from "./components/PaystubTable";
import { W2Table } from "./components/W2Table";
import { BankStatementTable } from "./components/BankStatementTable";
import { BankStatementItem } from "../../types/verified/bank-statment";
import { VerificationSpecificAdditionaData } from "../../types/income";
import { BenefitsStatementTable } from "./components/BenefitsStatementTable";

export const TablesSlice = ({
  currentItem,
  additionalData
}: {
  currentItem: VerifiedItem | VerifiedItem[];
  additionalData?: VerificationSpecificAdditionaData | null;
}) => {
  if (Array.isArray(currentItem)) {
    const groupedItemsSourceType = currentItem[0].income_source_type;
    if (groupedItemsSourceType === VerifyMethodType.BankStatement)
      return (
        <BankStatementTable
          incomeItems={currentItem as BankStatementItem[]}
          additionalData={additionalData?.[VerifyMethodType.BankStatement]}
        />
      );
  } else
    switch (currentItem.income_source_type) {
      case VerifyMethodType.Bank:
        return <BankSourcesTable income={[currentItem]} />;
      case VerifyMethodType.Payroll:
        return <PayrollTable income={[currentItem]} />;
      case VerifyMethodType.W2:
        return <W2Table incomeItems={[currentItem]} />;
      case VerifyMethodType.Paystub:
        return <PaystubTable incomeItems={[currentItem]} />;
      case VerifyMethodType.BenefitsStatement:
        return <BenefitsStatementTable incomeItems={[currentItem]} />;
    }
};
